import { render, staticRenderFns } from "./tableDaftarTes.vue?vue&type=template&id=b5a60fd0&scoped=true"
import script from "./tableDaftarTes.vue?vue&type=script&lang=js"
export * from "./tableDaftarTes.vue?vue&type=script&lang=js"
import style0 from "./tableDaftarTes.vue?vue&type=style&index=0&id=b5a60fd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5a60fd0",
  null
  
)

export default component.exports